const doc = [({"en":({"js":({"admin":({"highscore_generations":({"overall_highscore":({"export_csv":"Export CSV"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;